export default "__VITE_ASSET__8cd6ae52__"